module.exports = __webpack_public_path__ + "img/graduation-cap.bfd8496.svg";